import apiService from "./api";

export const getLearningDevelopment = async () => {
  return apiService("/blog/", "GET", undefined, true);
};

export const getLearningDevelopmentDetail = async (slug: string) => {
  return apiService(`/blog/${slug}/`, "GET", undefined, true);
};
